import { useSettings } from '../App/SettingsContext';

const QuoteOpenButton = ({ label }) => {
  const {
    settings,
    iconSvg,
    quoteCount,
    openSidebar,
  } = useSettings();

  const plugin_enabled = settings?.atqb_enable === 'true';
  const mobile_enabled = settings?.mob_enable === 'true';
  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (!plugin_enabled) return null;

  if (isMobile && !mobile_enabled) return null;

  return (
    <>
      <button
        className="quote-open-btn"
        onClick={openSidebar}
        style={{
          backgroundColor: settings?.mctqfw_quote_bg_color,
          color: settings?.mctqfw_quote_color,
        }}
      >
        {iconSvg && (
          <span
            className="quote-btn-icon"
            dangerouslySetInnerHTML={{ __html: iconSvg }}
          />
        )}
        {label}
      </button>

      <span
        className="quote-count-badge"
        style={{ 
          bottom: '73px', 
          right: '20px', 
          backgroundColor: settings?.mctqfw_quote_color, 
          color: settings?.mctqfw_quote_bg_color
        }}
      >
        {quoteCount}
      </span>
    </>
  );
};

export default QuoteOpenButton;
